module.exports = "<div class=\"o-wrapper\" [class.is-collapsed]=\"isSideMenuCollapsed\">\n    <app-main-menu *ngIf=\"authenticationService?.getAuthenticatedUser()\" (toggleSideMenu)=\"toggleSideMenu($event)\"></app-main-menu>\n    <div #mainContainer class=\"o-main-container\">\n        <app-header></app-header>\n        <div class=\"o-main-content\">\n            <router-outlet></router-outlet>\n        </div>\n    </div>\n</div>\n<app-notification-bar></app-notification-bar>"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/main/main.component.html
// module id = ./src/app/routes/main/main.component.html
// module chunks = 9